import * as THREE from 'three';
import { Weapon, WeaponConfig } from './Weapon';
import { ProjectilePool } from './ProjectilePool';

const LASER_CONFIG: WeaponConfig = {
  name: 'Laser Cannon',
  damage: 25,
  fireRate: 5, // 5 shots per second
  projectileSpeed: 150,
  ammoMax: 50,
  reloadTime: 1.5,
  spread: 0.02,
  automatic: true,
  projectileColor: new THREE.Color(0x00ffff),
  projectileSize: 0.15,
};

export class LaserWeapon extends Weapon {
  private projectilePool: ProjectilePool;

  constructor(projectilePool: ProjectilePool) {
    super(LASER_CONFIG);
    this.projectilePool = projectilePool;
  }

  protected createProjectile(origin: THREE.Vector3, direction: THREE.Vector3): void {
    this.projectilePool.spawn(
      origin,
      direction,
      this.getEffectiveProjectileSpeed(),
      this.getEffectiveDamage(),
      this.config.projectileColor,
      2 // 2 second lifetime
    );
  }
}
